<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="data"
      @submit="handleUpdate"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { createEditColumns } from './columns';

@Component
export default class PagesEdit extends Vue {

  data = {}

  get columns() {
    return createEditColumns.call(this, { html: this.data.content });
  }

  async mounted() {
    this.data = await this.$request.get(`/pages/${this.$route.params.id}`);
  }

  async handleUpdate(data) {
    const id = this.$route.params.id;
    await this.$autoLoading(
      this.$request.put(`/pages/${id}`, data)
    );
    this.$message.success('更新成功');
    this.$router.push({ name: 'pages.show', params: { id } });
  }
}
</script>
